import React from 'react';
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const TYPE_COLORS = {
  SOLAR_FLARE:              '#ffa726',
  GEOMAGNETIC_STORM:        '#7e57c2',
  CME:                      '#26c6da',
  RADIATION_BELT:           '#ef5350',
  SOLAR_ENERGETIC_PARTICLE: '#ab47bc',
  INTERPLANETARY_SHOCK:     '#26a69a',
};

const TYPE_LABELS = {
  SOLAR_FLARE:              'Solar Flare',
  GEOMAGNETIC_STORM:        'Geo. Storm',
  CME:                      'CME',
  RADIATION_BELT:           'Rad. Belt',
  SOLAR_ENERGETIC_PARTICLE: 'SEP',
  INTERPLANETARY_SHOCK:     'IPS',
};

export default function EventTypeChart({ eventsByType, loading }) {
  const keys    = Object.keys(eventsByType || {}).filter(k => (eventsByType[k] || 0) > 0);
  const labels  = keys.map(k => TYPE_LABELS[k] || k);
  const values  = keys.map(k => eventsByType[k] || 0);
  const colors  = keys.map(k => TYPE_COLORS[k] || '#78909c');

  const data = {
    labels,
    datasets: [{
      label: 'Events (last 30 days)',
      data: values,
      backgroundColor: colors.map(c => `${c}aa`),
      borderColor: colors,
      borderWidth: 1.5,
      borderRadius: 6,
      borderSkipped: false,
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: 'rgba(10,22,40,0.95)',
        borderColor: 'rgba(255,255,255,0.3)', borderWidth: 1,
        titleColor: '#e3f2fd', bodyColor: '#90caf9',
        padding: 10, cornerRadius: 8,
      },
    },
    scales: {
      x: {
        ticks: { color: '#546e7a', font: { size: 11 } },
        grid: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: { color: '#546e7a', font: { size: 11 }, stepSize: 1 },
        grid: { color: 'rgba(255,255,255,0.06)' },
      },
    },
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', mb: 2 }}>
          Events by Type (30 days)
        </Typography>
        {loading ? (
          <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2, bgcolor: 'rgba(255,255,255,0.05)' }} />
        ) : keys.length === 0 ? (
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>No data yet</Typography>
          </Box>
        ) : (
          <Box sx={{ flex: 1, minHeight: 200, position: 'relative' }}>
            <Bar data={data} options={options} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
